import React, { useEffect, useState } from "react";

import { Icon } from "Components/atoms/Icon";
import { CardCarousel } from "Components/molecules/CardCarousel";
import { rssAdapter } from "shared/adapters/rssAdapter";
import { useRssFeed } from "shared/hooks/useRssFeed";
import {
  CardsWrapperDesktop,
  CarouselWrapperDesktop,
  NextButtonDesktop,
  PrevButtonDesktop,
  TrackDesktop,
} from "./styles";

import { theme } from "styles/theme";

/**
 * Componente CarouselDesktop
 *
 * Exibe um carrossel contínuo para exibição de itens.
 */
export const CarouselDesktop: React.FC = () => {
  const { data: rawData, loading, error } = useRssFeed();
  const items = rssAdapter(rawData);

  const itemsPerView = 5;
  const [offset, setOffset] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(itemsPerView);

  const itemWidth = 18.15 * 16; // Largura do card (17.25rem) + gap (0.9rem)
  const totalItems = items.length;

  // Gerar itens duplicados para continuidade
  const infiniteItems = [
    ...items.slice(-itemsPerView),
    ...items,
    ...items.slice(0, itemsPerView),
  ];

  useEffect(() => {
    setOffset(itemsPerView * itemWidth); // Centraliza no primeiro item duplicado
  }, [itemWidth]);

  const handleNext = () => {
    if (!isTransitioning) {
      setIsTransitioning(true);
      setOffset((prev) => prev + itemWidth);
      setCurrentIndex((prev) => (prev + 1) % (totalItems + itemsPerView * 2));

      setTimeout(() => {
        if (currentIndex >= totalItems + itemsPerView) {
          setOffset(itemsPerView * itemWidth);
          setCurrentIndex(itemsPerView);
        }
        setIsTransitioning(false);
      }, 500);
    }
  };

  const handlePrev = () => {
    if (!isTransitioning) {
      setIsTransitioning(true);
      setOffset((prev) => prev - itemWidth);
      setCurrentIndex((prev) =>
        prev === 0 ? totalItems + itemsPerView - 1 : prev - 1,
      );

      setTimeout(() => {
        if (currentIndex < itemsPerView) {
          setOffset(totalItems * itemWidth);
          setCurrentIndex(totalItems + itemsPerView - 1);
        }
        setIsTransitioning(false);
      }, 500);
    }
  };

  if (loading) return <p>Carregando...</p>;
  if (error) return <p>Erro ao carregar o feed RSS.</p>;
  if (!items || items.length === 0) return <p>Nenhum dado disponível.</p>;

  return (
    <CarouselWrapperDesktop>
      <PrevButtonDesktop onClick={handlePrev}>
        <Icon
          name="MdKeyboardArrowLeft"
          library="md"
          size="large"
          color={theme.colors.darkGray}
        />
      </PrevButtonDesktop>
      <NextButtonDesktop onClick={handleNext}>
        <Icon
          name="MdKeyboardArrowRight"
          library="md"
          size="large"
          color={theme.colors.darkGray}
        />
      </NextButtonDesktop>

      <CardsWrapperDesktop>
        <TrackDesktop offset={offset}>
          {infiniteItems.map((card, index) => (
            <CardCarousel
              key={index}
              {...card}
              desktopVariant
              isSelected={index - 2 === currentIndex}
              onCLick={() => window.open(card.link, "_blank")}
            />
          ))}
        </TrackDesktop>
      </CardsWrapperDesktop>
    </CarouselWrapperDesktop>
  );
};
